exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.sales-product-box .bd-box{ border-top: 1px solid #EEEEEE;\n}\n.sales-product-box .left-box{ width: 69%; border-right: 1px solid #EEEEEE;\n}\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/home/part/Product.vue"],"names":[],"mappings":";AACA,4BAA4B,8BAA8B;CACzD;AACD,8BAA8B,WAAW,CAAC,gCAAgC;CACzE","file":"Product.vue","sourcesContent":["\n.sales-product-box .bd-box{ border-top: 1px solid #EEEEEE;\n}\n.sales-product-box .left-box{ width: 69%; border-right: 1px solid #EEEEEE;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b4a1f600","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/home/part/Product.vue
// module id = a4MY
// module chunks = 0